export class LoopFocus {
	constructor(object) {
		//-----------Main Trigger button for start operation
		this.button =
			typeof object.button === "string"
				? document.querySelector(object.button)
				: object.button;

		if (this.button) {
			this.clickButton = [];
			this.clickButtonCounter = 0;
			//-----------Loop Mode switcher
			this.loopMode = false;

			//-----------Current lvl of menu
			this.currLvl = -1;

			//-----------Trigger button
			if (object.trigger) {
				this.trigger =
					typeof object.trigger === "string"
						? document.querySelector(object.trigger)
						: object.trigger;
			}

			//-----------Container with main properties
			this.container = {
				main:
					typeof object.container.main === "string"
						? document.querySelector(object.container.main)
						: object.container.main,
				elements:
					typeof object.container.elements === "string"
						? [
								...document.querySelectorAll(
									`${object.container.main} > ${object.container.elements}`
								),
						  ]
						: object.container.elements,
			};
			this.container.firstElement = this.container.elements[0];
			this.container.beforeLastElement =
				this.container.elements[this.container.elements.length - 2];
			this.container.lastElement =
				this.container.elements[this.container.elements.length - 1];
			//-------------------------------------------

			//------------Array with Level Properties. Next index of array is next level of menu: 0 = 1, 1 = 2, etc
			this.anotherLevels = object.anotherLevels;

			if (this.button) {
				this.init();
				window.addEventListener("resize", () => {
					this.init();
				});
			}
		}
	}

	init() {
		const moreSpans = document.querySelectorAll("span.more");
		moreSpans.forEach((moreSpan) => {
			if (window.innerWidth < 1200) {
				moreSpan.setAttribute("tabindex", "0");
				moreSpan.setAttribute("role", "button");
			} else {
				moreSpan.removeAttribute("tabindex");
				moreSpan.removeAttribute("role");
			}
		});
		if (this.trigger) {
			this.button.addEventListener("click", () => {
				//----------Switch loop mode
				this.loopMode = true;
				//-----------------------

				this.activate([
					{
						trigger: this.trigger,
						notEq: this.container.firstElement,
						focusTarget: this.container.lastElement,
					},
					{
						trigger: this.container.lastElement,
						notEq: this.container.beforeLastElement,
						focusTarget: this.trigger,
					},
				]);
			});
			this.trigger.addEventListener("click", () => {
				//----------Switch loop mode
				this.loopMode = false;
				//-----------------------

				this.deactivate([
					{
						trigger: this.trigger,
					},
					{
						trigger: this.container.lastElement,
					},
				]);
			});
		} else {
			this.button.addEventListener("click", () => {
				//----------Switch loop mode
				this.loopMode = !this.loopMode;
				//-----------------------
				this.loopMode
					? this.activate([
							{
								trigger: this.button,
								notEq: this.container.firstElement,
								focusTarget: this.container.lastElement,
							},
							{
								trigger: this.container.lastElement,
								notEq: this.container.beforeLastElement,
								focusTarget: this.button,
							},
					  ])
					: this.deactivate([
							{
								trigger: this.button,
							},
							{
								trigger: this.container.lastElement,
							},
					  ]);
			});
		}
	}

	//-------------Function Activator. Each all elements from arguments and loop them. Checks if that container have more then 0 menus
	activate(array) {
		if (this.trigger) this.trigger.focus();

		array.forEach((el) => {
			const { trigger, notEq, focusTarget } = el;
			trigger.addEventListener(
				"focusout",
				this.checkButtons.bind(null, notEq, focusTarget)
			);
		});

		if (this.anotherLevels && this.anotherLevels.length > 0) {
			this.multiLevels(this.container.elements);
		}
	}

	//--------------Deactivating all eventlisteners
	deactivate(array) {
		this.button.focus();
		this.currLvl = -1;

		array.forEach((el) => {
			const { trigger } = el;
			trigger.removeEventListener("focusout", this.checkButtons);
		});
	}

	//---------------This is for more level menus. Getting List of elements and each them
	multiLevels(elements) {
		const that = this;
		elements.forEach((el) => {
			for (let i = 0; i < that.clickButton.length; i++) {
				el.removeEventListener("click", that.clickButton[i]);
				el.removeEventListener("keydown", that.clickButton[i]);
			}
		});
		elements.forEach((el, index) => {
			let button = el;
			button.addEventListener(
				"click",
				(that.clickButton[that.clickButtonCounter] = function (e) {
					that.clickListener(button);
				})
			);
			that.clickButtonCounter++;
			button.addEventListener(
				"keydown",
				(that.clickButton[that.clickButtonCounter] = function (e) {
					if (e.keyCode === 13 || e.keyCode === 32) {
						if (button.tagName === "SPAN") {
							button.click();
						}
					}
				})
			);
			that.clickButtonCounter++;
		});
	}

	clickListener(button) {
		const that = this;
		that.currLvl++;
		//----------- Get Parametres by index in anotherLevels array
		const lvlParameters = that.anotherLevels[that.currLvl];
		//------------------------------------------

		if (lvlParameters) {
			//----------- Getting Parent/All Links/First Element/Last Element/Before Last Element/Return Button
			let nextLvl = button.parentElement.querySelector(lvlParameters.container);
			if (nextLvl) {
				let nextLvlElements = [...nextLvl.querySelectorAll(lvlParameters.elements)];
				let firstElement = nextLvlElements[0];
				let lastElement = nextLvlElements[nextLvlElements.length - 1];
				let beforeLastElement = nextLvlElements[nextLvlElements.length - 2];
				//------------------------------------------

				setTimeout(function () {
					let returnButton = nextLvl.querySelector(lvlParameters.returnButton);
					if (returnButton) {
						returnButton.focus();
						returnButton.addEventListener(
							"focusout",
							that.checkButtons.bind(null, firstElement, lastElement)
						);
						returnButton.addEventListener("click", function (el) {
							that.currLvl--;
							button.focus();
						});
						// ----- Here creates loop for next lvl menu
						lastElement.addEventListener(
							"focusout",
							that.checkButtons.bind(null, beforeLastElement, returnButton)
						);

						// -----------------------------------------
					}
				}, 300);
				
				//-------------------- If we have more than 2 lvls of menu, call that function one more time
				if (that.anotherLevels.length > that.currLvl)
				that.multiLevels(nextLvlElements);
			}
		}
	}

	//-------------Function checks button, end focus variable 'focusTarget'
	checkButtons(notEq, focusTarget, ev) {
		let { relatedTarget } = ev;
		const backButton = document.querySelector(".backToSite");
		const backButton2 = document.querySelector(".backToLevel");
		if (
			relatedTarget !== notEq &&
			relatedTarget !== backButton &&
			relatedTarget !== backButton2
		)
			focusTarget.focus();
	}
}
